import { gql } from '@apollo/client'

export type MutationVars = {
  customerId: string
  subjectId: string
  personId: string
  requestSubject: string
  requestMessage: string
  recommendationType: string
}

export type Response = {
  createDataRequest: string
}

const mutation = gql`
  mutation createDataRequest(
    $customerId: String!
    $subjectId: String!
    $personId: String!
    $requestSubject: String!
    $requestMessage: String!
    $recommendationType: String!
  ) {
    createDataRequest(
      customerId: $customerId
      subjectId: $subjectId
      personId: $personId
      requestSubject: $requestSubject
      requestMessage: $requestMessage
      recommendationType: $recommendationType
    )
  }
`

export default mutation
